/* !! DO NOT EDIT manually, this file is AUTO-GENERATED. Any edits to the file will be overwritten during the build. Edits should be made to the SVG with a matching name */ import * as React from "react";
const SvgItalicC = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 2048 2048",
        width: "1em",
        height: "1em",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        d: "m1792 229-42 193q-91-61-193-93t-213-32q-112 0-209 27t-179 77-144 120-107 156-67 185-23 208q0 122 33 223t98 175 162 113 224 40q61 0 116-6t107-19 104-35 105-52l-44 198q-104 47-208 66t-219 19q-158 0-283-52t-213-147-133-223-46-284q0-209 66-384t188-303 294-199 385-72q115 0 226 24t215 77z"
    }));
export default SvgItalicC;
